export enum ProjectTypes {
  Активные = 1,
}
